__turbopack_context__.v({
  "button": "style-module-scss-module__6u9SSq__button",
  "component": "style-module-scss-module__6u9SSq__component",
  "first-layout": "style-module-scss-module__6u9SSq__first-layout",
  "heading": "style-module-scss-module__6u9SSq__heading",
  "image-wrapper": "style-module-scss-module__6u9SSq__image-wrapper",
  "info": "style-module-scss-module__6u9SSq__info",
  "left-column": "style-module-scss-module__6u9SSq__left-column",
  "note": "style-module-scss-module__6u9SSq__note",
  "number": "style-module-scss-module__6u9SSq__number",
  "right-column": "style-module-scss-module__6u9SSq__right-column",
  "timing": "style-module-scss-module__6u9SSq__timing",
  "title": "style-module-scss-module__6u9SSq__title",
  "two-column-layout": "style-module-scss-module__6u9SSq__two-column-layout",
});
